import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Intro,
  SectionTitle,
  Showcase,
  Header,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            Text inputs are form inputs that gather plain text information from
            users. Every text input component must have a label and an input
            field. Optional placeholder text can also be added to provide the
            user with example input and guidance for filling in the field.
          </p>
        </Intro>

        <SectionTitle>Variants</SectionTitle>

        <Showcase
          site={data.site}
          title="Text Input"
          text="Use the default text field when the expected input is a single line, such as a name or phone number."
          code={code.input}
        >
          <div>
            <input
              type="text"
              class="c-text-input"
              placeholder="e.g. Homer J. Simpson"
              id="text-input-1"
            />
          </div>
        </Showcase>
        <Showcase
          id="TextArea"
          site={data.site}
          title="Text Area"
          text="	Use the textarea field when the expected input is more than one line, such as a comment or contact request."
          code={code.textarea}
        >
          <div>
            <textarea
              name=""
              id="text-area"
              class="c-textarea"
              placeholder="Textarea placeholder"
            ></textarea>
          </div>
        </Showcase>
        <SectionTitle>States</SectionTitle>
        <p>
          In addition to the default state, both types of text inputs have
          hover, focus, change, blur and error states. The error state must be
          used with an{' '}
          <Link
            to={'/' + data.site + '/components/inline-error/design'}
            class="link"
          >
            input error
          </Link>{' '}
          component. An optional disabled state is also available.
        </p>

        <Showcase
          site={data.site}
          title="Text Input in Disabled State"
          text="Use the disabled state when another action must be completed before the user can interact with the input."
          code={code.disabled}
        >
          <div>
            <input
              type="text"
              class="c-text-input--disabled"
              placeholder="e.g. Homer J. Simpson"
              value="John Doe"
              id="text-input-3"
              disabled
            />
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Text Input in Error State"
          text={
            <p>
              A text input or text area in the error state must be used with an{' '}
              <Link
                to={'/' + data.site + '/components/inline-error/design/'}
                className="link"
              >
                input error
              </Link>{' '}
              component to guide the user in correcting the error.
            </p>
          }
        >
          <div>
            <input
              type="text"
              class="c-text-input c-text-input--error"
              placeholder="Hot tea!"
              id="text-input-1"
            />
            <span class="c-inline-error">
              <i class="icon icon--error c-inline-error__icon"></i>
              <span class="c-inline-error__content">
                Tell me something good.
              </span>
            </span>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Keep a margin of 16px between the text input and any components above
          or below it. Text inputs will fill 100% width of the parent container
          when standing alone. When inline with another component, they will
          fill 50% width. Keep a 16px margin between the text input and any
          inline components.
        </p>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Placeholders should give the user an example or show the required
          format of the input. Never use a placeholder instead of a label, as
          the user will lose the prompt once they begin typing. Use sentence
          case with no end punctuation, unless otherwise dictated by the input
          format.
        </p>

        <hr />
        {/* <SectionTitle>Usage Instance</SectionTitle>
        <p>
          The text input component is used in the following patterns, which each
          have additional guidelines:
        </p>
        <ul>
          <li> Inline Help</li>
          <li> User ID (Default) </li>
          <li> User ID (Remembered) </li>
          <li>Passcode </li>
          <li> Passcode Creation </li>
          <li> PIN </li>
          <li> PIN Creation </li>
          <li> Credit/Debit Card Number </li>
          <li> Social Security Number (Full) </li>
          <li> Social Security Number (Last 4 Digits) </li>
          <li> One Time Passcode </li>
          <li> Account Number </li>
          <li> Security Question Answer</li>
          <li> Security Question Creation </li>
          <li> Currency </li>
          <li> Date (Full – MM/DD/YYYY) </li>
          <li>Date (Abbreviated – MM/YY) </li>
          <li> Phone Number </li>
          <li> Name </li>
          <li> Primary Address </li>
          <li>Routing Number</li>
        </ul> */}
      </Layout>
    </>
  )
}

export const code = {
  /*
  input: `<label class="c-label">Label Name</label>
<input type="text" class="c-text-input" placeholder="Text input placeholder" />
`,
  textarea: `<label class="c-label">Label Name</label>
<textarea name="" id="" class="c-textarea" placeholder="Textarea placeholder"></textarea>
`,
  success: `<label class="c-label">Label Name</label>
<input type="text" class="c-text-input" placeholder="Text input placeholder" value="John Doe" />
`,
  disabled: `<label class="c-label">Label Name</label>
<input type="text" class="c-text-input--disabled" placeholder="Text input placeholder" value="John Doe" disabled />
`*/
}
